import React from "react"
import { Tiny } from "@/components/standard/BFText"
import { View } from "react-native"

export const MiniRequirementMessage = ({
  message,
  displays,
  className,
  pseudoEnabled = true,
}: {
  message: string
  displays: boolean
  className?: string
  pseudoEnabled?: boolean
}) => {
  return (
    <View className={className}>
      {displays && pseudoEnabled && (
        <Tiny className={`mt-2 h-4 text-red-orange`}>{message}</Tiny>
      )}
    </View>
  )
}
